import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Welcome, Signup, Login } from './screens/Auth'
import Home from './screens/Home'
import { Receive, ShareLanding } from './screens/Receive'
import KnockLanding from './screens/KnockLanding'
import { getSession } from './services/auth'
import InstallPrompt from './components/InstallPrompt'

export default function App() {
  const signedIn = !!getSession()
  return (
    <BrowserRouter>
      <InstallPrompt />
      <Routes>
        <Route path="/" element={signedIn ? <Navigate to="/home" replace /> : <Welcome />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/receive/:tinglId" element={<Receive />} />
        <Route path="/t/:shortCode" element={<ShareLanding />} />
        <Route path="/u/:username" element={<KnockLanding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
